// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__37bV7","activeHandle":"RangeSlider_activeHandle__19JtZ"};